export default "__VITE_ASSET__a0363ffb__"